export const projects = [
  {
    img: "https://res.cloudinary.com/dicjyi6ic/image/upload/v1681194228/localease_xid0ot.png",
    title: "NearBuy-Clone",
    des: "It is a clone website of NearBuy, which deals in finding things to eat and buy, book a table at restaurants, spas, gift cards near your location",
    demo: "",
    live: "https://localease.netlify.app/ ",
    gitHub: "https://github.com/shreshthkr/poetic-minute-6695",
    technologies: [
      "JavaScript",
      "React",
      "Redux",
      "Node",
      "Express",
      "MongoDB",
    ],
  },
  {
    img: "https://res.cloudinary.com/dicjyi6ic/image/upload/v1681194154/indeanexpress_hgpgid.png",
    title: "IndianExpress-Clone",
    des: "This project is clone of well known website known as Indian Express builded by us. The purpose of building this project is only and only for educational purposes. All copyrights are reserved by Indian Express. We hereby declare that we will not use this for any bad purposes. Thank You!",
    demo: "",
    live: "https://astounding-froyo-9f44a4.netlify.app/",
    gitHub: "https://github.com/ankit2341/Indian-Express-clone",
    technologies: [
      "JavaScript",
      "React",
      "Html",
      "CSS"
      
    ],
  },
  {
    img: "https://res.cloudinary.com/dicjyi6ic/image/upload/v1681194132/buffer_qybadq.png",
    title: "Buffer Clone",
    des: "Website provides Manage your social meadia platforms like Instagram, Facebook,etc. It also provide update post or remove post from different social media platforms and analytics",
    demo: "",
    live: "https://calm-elf-73b415.netlify.app/",
    gitHub: "https://github.com/VinayRinait/Buffer_Website_Clone",
    technologies: ["React", "redux", "HTML", "CSS", "javaScript"],
  },
  {
    img: "https://res.cloudinary.com/dicjyi6ic/image/upload/v1681194100/himalaya_qlrim3.png",
    title: "Himalayausa-Clone",
    des: "Himalaya Wellness Company (formerly Himalaya Drug Company) is an Indian multinational pharmaceutical company based in Bengaluru, Karnataka, India. It was originally established by Mohammad Manal in Dehradun in 1930.It produces health care products under the name Himalaya Herbal Healthcare whose products include ayurvedic ingredients.",
    demo: "",
    live: "https://himalayausa1.netlify.app/",
    gitHub:
      "https://github.com/saurabhKJ7/HIMALAYAUSA-CLONE",
    technologies: ["HTML", "javaScript","CSS"],
  },
];
